import React from 'react';
import {useSelector} from "react-redux";
import Typography from "@material-ui/core/Typography";
import {Backdrop, CircularProgress, Grid, IconButton, Paper} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {getProjects} from "../../redux/reducers/project-reducer.js";
import {ContractProjectLayout} from "../../layouts/ContractProjectHeaderLayout/ContractProjectHeaderLayout";
import LibraryContainer from "../../containers/LibraryContainer/LibraryContainer.jsx";
import {selectLoading} from "../../redux/reducers/library-reducer.js";
import SearchIcon from '@material-ui/icons/Search';
import {useDialog} from "../../hooks/useDialog.js";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        width: '100%',
    },
    header: {
        paddingBottom: theme.spacing(1)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))

const LibraryPage = () => {
    const {selectedProject, loading: projectLoading} = useSelector(getProjects)

    const classes = useStyles()

    const searchDialog = useDialog()

    const libraryLoading = useSelector(selectLoading)

    return (
        <ContractProjectLayout>
            <Backdrop className={classes.backdrop} open={Boolean(libraryLoading || projectLoading)}>
                <CircularProgress color={'inherit'}/>
            </Backdrop>
            <Grid container direction={'column'}>
                <Grid item container justifyContent={'space-between'} alignItems={'center'}>
                    <Grid item>
                        <Typography className={classes.header} variant={'h5'}>Библиотека документов</Typography>
                    </Grid>
                    <Grid item>
                        <IconButton size={'small'} onClick={searchDialog.handleOpen}><SearchIcon/></IconButton>
                    </Grid>
                </Grid>
                <Grid item>
                    <Paper className={classes.paper}>
                        <LibraryContainer
                            projectID={selectedProject?.id}
                            loading={libraryLoading || projectLoading}
                            searchDialogOpen={searchDialog.open}
                            onSearchDialogClose={searchDialog.handleClose}
                            shadow={true}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </ContractProjectLayout>
    );
};

export default LibraryPage;